import each from 'lodash/each';
import ValidatorHelper from 'viralstyle-ui/src/ValidatorHelper';

export const accountValidator = new ValidatorHelper({
  public_name: {
    rules: 'required|max:30',
    pretty: 'public name',
  },
  name: {
    rules: 'required|max:50|latin',
    pretty: 'full name',
  },
  street_1: {
    rules: 'max:50|latin|min:3',
    pretty: 'address line 1',
  },
  street_2: {
    rules: 'max:50|latin',
    pretty: 'address line 2',
  },
  city: {
    rules: 'max:50|latin|min:3',
    pretty: 'city / town',
  },
  province: {
    rules: 'max:50|latin',
    pretty: 'state / province / region',
  },
  zip: {
    rules: 'max:50|alpha_dash|latin',
    pretty: 'zip / postal code',
  },
  mobile: {
    rules: 'max:50|numeric',
    pretty: 'phone number',
  },
});

export const subUserValidator = new ValidatorHelper({
  email: {
    rules: 'required|email',
    pretty: 'email'
  },
  password: {
    rules: 'required|min:8|password|max:50',
    pretty: 'password'
  },
  role: {
    rules: 'required',
    pretty: 'role'
  },
  view_payouts: {
    rules: 'required',
    pretty: 'view payouts permission',
  },
  request_payouts: {
    rules: 'required',
    pretty: 'request payouts permission',
  },
  access_domains: {
    rules: 'required',
    pretty: 'access domains permission',
  },
  allowed_domains: {
    rules: '',
    pretty: 'allowed domains',
  },
});

export const changePasswordValidator = new ValidatorHelper({
  password: {
    rules: 'required|min:8|max:50',
    pretty: 'password'
  },
  newPassword: {
    rules: 'required|min:8|password|max:50',
    pretty: 'new password'
  },
  confirmPassword: {
    rules: 'required|min:8|password|max:50',
    pretty: 'password'
  }
});

export const paymentPaypalValidator = new ValidatorHelper({
  paypal_email: {
    rules: 'required|email|max:100',
    pretty: 'PayPal email'
  }
});

export const paymentAchValidator = new ValidatorHelper({
  name: {
    rules: 'required|min:3|max:100',
    pretty: 'name'
  },
  bank: {
    rules: 'required|min:3|max:100',
    pretty: 'bank'
  },
  type: {
    rules: 'required|max:100',
    pretty: 'account type'
  },
  type2: {
    rules: 'required|max:100',
    pretty: 'client type'
  },
  routing: {
    rules: 'required|digits:9',
    pretty: 'routing number'
  },
  account: {
    rules: 'required|min:3|max:100',
    pretty: 'account number'
  }
});

export const paymentCheckValidator = new ValidatorHelper({
  name: {
    rules: 'required|min:3|max:100',
    pretty: 'name'
  },
  address: {
    rules: 'required|min:3|max:100',
    pretty: 'address'
  },
  apt: {
    rules: 'max:100',
    pretty: 'apt'
  },
  city: {
    rules: 'required|min:3|max:100',
    pretty: 'city'
  },
  state: {
    rules: 'required|min:3|max:100',
    pretty: 'state'
  },
  pin_code: {
    rules: 'required|max:100|alpha_dash',
    pretty: 'zip'
  },
  mobile: {
    rules: 'required|max:100',
    pretty: 'phone number'
  },
});

export const paymentWireValidator = new ValidatorHelper({
  recipient_name: {
    rules: 'required|min:3|max:50',
    pretty: 'recipient name'
  },
  recipient_address: {
    rules: 'required|min:3|max:50',
    pretty: 'recipient address'
  },
  recipient_apt: {
    rules: 'max:50',
    pretty: 'recipient apt'
  },
  recipient_city: {
    rules: 'required|min:3|max:50',
    pretty: 'recipient city'
  },
  recipient_state: {
    rules: 'required|min:2|max:50',
    pretty: 'recipient state / province / region'
  },
  recipient_zip: {
    rules: 'required|max:50|alpha_dash',
    pretty: 'recipient zip'
  },
  recipient_country: {
    rules: 'required|min:2|max:50',
    pretty: 'recipient country'
  },
  account_number: {
    rules: 'required|min:3|max:50',
    pretty: 'account number'
  },
  bank_routing: {
    rules: 'required|digits:9',
    pretty: 'bank routing number'
  },
  account_type: {
    rules: 'required|max:50',
    pretty: 'account type'
  },
  bank_name: {
    rules: 'required|min:3|max:50',
    pretty: 'bank name'
  },
  bank_address: {
    rules: 'required|min:3|max:50',
    pretty: 'bank address'
  },
  bank_city: {
    rules: 'required|min:3|max:50',
    pretty: 'bank city'
  },
  bank_state: {
    rules: 'required|min:2|max:50',
    pretty: 'bank state / province / region'
  },
  bank_zip: {
    rules: 'required|max:50|alpha_dash',
    pretty: 'bank zip'
  },
  bank_country: {
    rules: 'required|min:2|max:50',
    pretty: 'bank country'
  },
  bank_swift_code: {
    rules: 'min:8|max:11',
    pretty: 'bank swift code',
  }
});

export const emailKeyValidator = new ValidatorHelper({
  apiKey: {
    rules: 'required',
    pretty: 'API key'
  }
});

export const trackingValidator = new ValidatorHelper({
  'disable_vs_retargeting': {
    rules: 'required'
  },
  ga: {
    rules: 'ga',
  },
  'facebook.id': {
    rules: 'max:50',
    pretty: 'facebook',
  },
  'facebook.use_product_group': {
    rules: '',
    pretty: 'use product group',
  },
  twitter: {
    rules: 'max:50',
    pretty: 'twitter conversion pixel',
  },
  tiktok: {
    rules: 'max:50',
    pretty: 'tiktok conversion pixel',
  },
  'google.id': {
    rules: 'max:50',
    pretty: 'google adwords conversion pixel',
  },
  'google.label': {
    rules: 'max:50',
    pretty: 'google adwords conversion label',
  },
  'adroll.pixel_id': {
    rules: 'max:50',
    pretty: 'adroll pixel id',
  },
  'adroll.adv_id': {
    rules: 'max:50',
    pretty: 'adroll advertiser id',
  },
  perfect: {
    rules: 'max:50',
    pretty: 'perfect pixel id',
  },
  pinterest: {
    rules: 'max:50',
    pretty: 'pinterest tag id',
  },
  custom: {
    rules: 'max:300|url:true',
    pretty: 'custom image pixel URL'
  },
});

export const payoneerPayValidator = new ValidatorHelper({
  amount: {
    rules: 'required|min_value:0.01',
    pretty: 'amount',
  },
  terms: {
    rules: 'required',
    pretty: 'terms',
  },
});

class CustomVarValidators {
  constructor() {
    this.validators = {};
  }

  hasErrors() {
    let hasErrors = false;

    each(this.validators, validator => {
      if (validator.hasErrors()) {
        hasErrors = true;
        return false;
      }
    });

    return hasErrors;
  }

  clear() {
    each(this.validators, validator => {
      validator.clear();
    });
  }
};

export const customVarValidators = new CustomVarValidators();